import { API_BASE } from "@/lib/api";

// Registra un clic en un CTA clave. Nunca debe bloquear ni romper la navegación.
export function trackClick(action, { trip_slug = "", trip_name = "" } = {}) {
  try {
    const body = JSON.stringify({
      action,
      trip_slug,
      trip_name,
      page_url: typeof window !== "undefined" ? window.location.href : "",
    });
    const url = `${API_BASE}/clicks`;
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // silencio
  }
}
